export const GET_COMMISSIONS_BY_AGENT = "GET_COMMISSIONS_BY_AGENT";
export const GET_COMMISSIONS_BY_AGENT_SUCCESS = "GET_COMMISSIONS_BY_AGENT_SUCCESS";
export const GET_COMMISSIONS_BY_AGENT_ERROR = "GET_COMMISSIONS_BY_AGENT_ERROR";

export const GET_COMMISSION_EXCEL = "GET_COMMISSION_EXCEL";
export const GET_COMMISSION_EXCEL_SUCCESS = "GET_COMMISSION_EXCEL_SUCCESS";
export const GET_COMMISSION_EXCEL_ERROR = "GET_COMMISSION_EXCEL_ERROR";